<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :submit="handleSubmitFormEditGroup"
        :width="sizeSlideOver"
        :undo-enable="true"
        :title="groupIsSelectedToEdit?.name"
        @close="handleClose"
        @undo="undo"
        @visible="onVisible">
        <template #body>
            <div class="hts-company-group-ignore-add-group">
                <div
                    class="hts-company-group-ignore-add-group__container-body"
                    :class="sizeItemInput">
                    <hts-card :title="$t('labels.editGroup')">
                        <div
                            class="grid gap-5"
                            :class="columnClass">
                            <group-name
                                v-model="dataFormCompanyGroup.name"
                                name="name"
                                prop="name"
                                :text="itemName" />
                            <group-type
                                v-model="dataFormCompanyGroup.type"
                                name="type"
                                prop="type" />
                            <hts-form-input
                                :placeholder="companyName"
                                :label="$t('labels.companyName')"
                                :color="props.color"
                                :disabled="true"
                                name="company"
                                prop="company" />
                            <hts-form-input
                                v-model="dataFormCompanyGroup.description"
                                :label="$t('labels.description')"
                                :color="props.color"
                                name="description"
                                prop="description" />
                        </div>
                    </hts-card>
                </div>
            </div>
        </template>
    </hts-slide-over>
</template>

<script setup lang="ts">
import GroupName from './ignore/group-name.vue'
import GroupType from './ignore/group-type.vue'
import dataForm from './imports/model'

const store = $store()
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: Number,
    default: 0
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  groupIsSelectedToEdit: {
    type: Object,
    default: () => {}
  }
})
const emits = defineEmits(['close', 'refreshTables', 'undo'])
const itemName = ref('')
const handleClose = () => {
  emits('close')
}
const _init = () => {
  Object.assign(dataFormCompanyGroup, props.groupIsSelectedToEdit)
  itemName.value = dataFormCompanyGroup.name
}
const onVisible = () => {
  _init()
}
const undo = () => {
  _init()
}
const companyName = ref('')
onMounted(() => {
  companyName.value = store.system.company.name
})
const dataFormCompanyGroup = reactive({ ...dataForm.initValue })

const handleSubmitFormEditGroup = async () => {
  const api = $url.companyGroup.editGroup
  const data = {
    type: dataFormCompanyGroup.type,
    id: props.groupIsSelectedToEdit._id,
    name: dataFormCompanyGroup.name,
    description: dataFormCompanyGroup.description
  }
  const response = await $api(api, { body: data })
  if (!response) {
    return true
  }
  const responseData: any = response.data?.value
  if (!responseData) {
    return true
  }
  if (responseData.success) {
    process.client && $toast().success($t('labels.editSuccess'))
    emits('refreshTables')
    emits('close')
  }
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-5'
})
</script>
